module.exports = __webpack_public_path__ + "cbcb60efe0767bc9675b1ed89942c341.png";